export const copyToClipboard = async (text: string | undefined) => {
  const type = 'text/plain';

  if (!text) {
    return;
  }

  const blob = new Blob([text], { type });

  const data = [new ClipboardItem({ [type]: blob })];

  await navigator.clipboard.write(data);
};
